import type { RecurringJob } from "@/lib/jobs-types";

// Pure rules of the per-recurring-job details page (sc-114201). No React, no router, no fetch.

/** The Hangfire state whose run the details page tails live. */
export const LIVE_JOB_STATE = "Processing";

/** The details page's path for one recurring job: `/jobs/<id>`, the id URL-encoded as one segment. */
export function jobDetailsPath(recurringJobId: string): string {
  return `/jobs/${encodeURIComponent(recurringJobId)}`;
}

/** The settings scope a recurring job's own settings live under. */
export function jobSettingsScope(recurringJobId: string): string {
  return `job:${recurringJobId}`;
}

/**
 * The run the inline live log shows. A Processing definition names its run, replacing any earlier one; any other
 * state keeps whatever is shown, so the panel leaves "live" on its tail's `finished` flag and never on
 * `last_job_state` alone. `null` until a Processing run has been seen.
 */
export function nextLiveRunId(
  current: string | null,
  job: Pick<RecurringJob, "last_job_id" | "last_job_state"> | undefined
): string | null {
  if (job?.last_job_state === LIVE_JOB_STATE && job.last_job_id) return job.last_job_id;
  return current;
}
